module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"Nation":"Nazione","Citizenship":"Cittadinanza"},"en":{"Nation":"Nation","Citizenship":"Citizenship"}}')
  delete Component.options._Ctor
}
